export type StatusValueOptionType = 'published' | 'draft' | 'archived';
export type StatusOptionType = {
  label: string;
  value: StatusValueOptionType;
};

type StatusOptionsType = StatusOptionType[];

export const DEFAULT_VISIBLE_STATUS_VALUES: StatusValueOptionType[] = [
  'draft',
  'published',
];

const StoryStatusOptions: StatusOptionsType = [
  { label: 'Draft', value: 'draft' },
  { label: 'Published', value: 'published' },
  { label: 'Archived', value: 'archived' },
];

export const StatusFilterOptions: StatusOptionsType = [
  { label: 'Draft', value: 'draft' },
  { label: 'Published', value: 'published' },
  { label: 'Archived', value: 'archived' },
];

export const getDefaultVisibleStatusOptions = (): StatusOptionsType =>
  StatusFilterOptions.filter(option =>
    DEFAULT_VISIBLE_STATUS_VALUES.includes(option.value)
  );

export const normalizeStatusValue = (
  status?: string | null
): StatusValueOptionType | undefined => {
  const normalizedStatus = status?.toLowerCase();

  if (
    normalizedStatus === 'draft' ||
    normalizedStatus === 'published' ||
    normalizedStatus === 'archived'
  ) {
    return normalizedStatus;
  }

  return undefined;
};

export default StoryStatusOptions;
